<div class="row m-0 pt-1">
  <p-inputGroup class="col-md-12 mt-3">
    <div class="width-100">
      <span class="p-float-label">
        <input
          #cpfCnpjInput
          (click)="cpfCnpjInput.select()"
          pInputText
          type="text"
          [formControl]="form.get('cpf_cnpj')"
          [mask]="
            parceiroType === 'deposito'
              ? '00.000.000/0000-00'
              : '000.000.000-00||00.000.000/0000-00'
          "
          (animationend)="removeValidatorMask()"
          (blur)="checkCpfCnpj()"
        />
        <p-inputGroupAddon
          [ngClass]="{
            'p-inputgroup-addon-right': true,
            'cursor-pointer':
              !loadingParceiro &&
              form.get('cpf_cnpj').value &&
              (form.get('cpf_cnpj').valid || form.get('cpf_cnpj').disabled)
          }"
          (click)="
            !loadingParceiro &&
            form.get('cpf_cnpj').value &&
            (form.get('cpf_cnpj').valid || form.get('cpf_cnpj').disabled)
              ? openDialogConsultaPredictus()
              : null
          "
          [pTooltip]="
            !loadingParceiro &&
            form.get('cpf_cnpj').value &&
            (form.get('cpf_cnpj').valid || form.get('cpf_cnpj').disabled)
              ? 'Consultar dados'
              : ''
          "
        >
          <i
            [class]="
              !form.get('cpf_cnpj').value || form.get('cpf_cnpj').invalid
                ? 'pi pi-fw pi-search text-gray'
                : loadingParceiro
                ? 'pi pi-fw pi-spin cursor-pointer pi-spinner text-primary'
                : 'pi pi-fw pi-search cursor-pointer text-primary'
            "
          ></i>
        </p-inputGroupAddon>
        <label>
          {{ parceiroType === 'deposito' ? 'CNPJ' : 'CPF/CNPJ' }}
        </label>
      </span>
      <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('repeated')">
        {{ messages.cpf_cnpj.repeated }}
      </small>
      <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('required')">
        {{ messages.cpf_cnpj.required }}
      </small>
      <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('pattern')">
        {{ messages.cpf_cnpj.pattern }}
      </small>
      <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('duplicate')">
        {{ messages.cpf_cnpj.duplicate }}
      </small>
      <small class="p-error" *ngIf="form.get('cpf_cnpj').hasError('maxlength')">
        {{ messages.cpf_cnpj.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('cpf_cnpj').hasError('validateCPF')"
      >
        {{ messages.cpf_cnpj.validateCPF }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('cpf_cnpj').hasError('validateCNPJ')"
      >
        {{ messages.cpf_cnpj.validateCNPJ }}
      </small>
    </div>
  </p-inputGroup>

  <div class="col-md-12 mt-3">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label>
        {{
          parceiroType !== 'cliente' && parceiroType !== 'deposito'
            ? 'Nome/razão social'
            : !notRequired
            ? 'Nome/razão social'
            : 'Apelido/nome fantasia'
        }}
      </mat-label>
      <input
        matInput
        type="text"
        [formControl]="form.get('nome_razao_social')"
      />
    </mat-form-field>
    <small
      class="p-error"
      *ngIf="form.get('nome_razao_social').hasError('required')"
    >
      {{ messages.nome_razao_social.required }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('nome_razao_social').hasError('maxlength')"
    >
      {{ messages.nome_razao_social.maxlength }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('nome_razao_social').hasError('minlength')"
    >
      {{ messages.nome_razao_social.minlength }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('nome_razao_social').hasError('isEmptyValue')"
    >
      {{ messages.nome_razao_social.isEmptyValue }}
    </small>
  </div>

  <div class="col-md-12 mt-3">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label>
        {{
          parceiroType !== 'cliente' && parceiroType !== 'deposito'
            ? 'Apelido/nome fantasia'
            : !notRequired
            ? requiredFantasia
              ? 'Apelido/nome fantasia *'
              : 'Apelido/nome fantasia'
            : 'Nome/razão social'
        }}
      </mat-label>
      <input
        matInput
        type="text"
        [formControl]="form.get('apelido_nome_fantasia')"
        [readonly]="notRequired"
      />
    </mat-form-field>
    <small
      class="p-error"
      *ngIf="form.get('apelido_nome_fantasia').hasError('maxlength')"
    >
      {{ messages.apelido_nome_fantasia.maxlength }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('apelido_nome_fantasia').hasError('minlength')"
    >
      {{ messages.nome_razao_social.minlength }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('apelido_nome_fantasia').hasError('isEmptyValue')"
    >
      {{ messages.nome_razao_social.isEmptyValue }}
    </small>
  </div>

  <div class="col-md-6 mt-3">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label>Inscrição estadual/RG</mat-label>
      <input
        matInput
        type="text"
        (keydown)="notText($event)"
        (blur)="checkRgInscEstadual()"
        [formControl]="form.get('rg_insc_est')"
        [readonly]="notRequired"
      />
    </mat-form-field>
    <small class="p-error" *ngIf="form.get('rg_insc_est').hasError('pattern')">
      {{ messages.rg_insc_est.pattern }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('rg_insc_est').hasError('maxlength')"
    >
      {{ messages.rg_insc_est.maxlength }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('rg_insc_est').hasError('duplicate')"
    >
      {{ messages.rg_insc_est.duplicate }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('rg_insc_est').hasError('existSpecialChar')"
    >
      {{ messages.rg_insc_est.existSpecialChar }}
    </small>
    <small
      class="p-error"
      *ngIf="form.get('rg_insc_est').hasError('isEmptyValue')"
    >
      {{ messages.rg_insc_est.isEmptyValue }}
    </small>
  </div>

  <div class="col-md-6 mt-3">
    <mat-form-field appearance="outline" color="primary" class="width-100">
      <mat-label>Data de nascimento/Data de abertura</mat-label>
      <input
        [id]="ID_FIELD_DTNASC"
        matInput
        appFormatData
        (focus)="onFocus($event, true)"
        (blur)="focusElement === ID_DTPICKER_NASC ? null : onFocus(null, false)"
        [formControl]="form.get('data_nascimento')"
        [matDatepicker]="dataPicker"
      />
      <mat-datepicker-toggle
        *ngIf="
          inputElementDtNasc
            ? inputElementDtNasc
            : !form.get('data_nascimento').value
            ? focusElement === ID_FIELD_DTNASC ||
              focusElement === ID_DTPICKER_NASC
            : focusElement === ID_FIELD_DTNASC ||
              form.get('data_nascimento').value
        "
        (click)="onFocus({ target: { id: ID_DTPICKER_NASC } })"
        (mouseover)="onFocus({ target: { id: ID_DTPICKER_NASC } })"
        (mouseout)="onFocus(null)"
        matSuffix
        [for]="dataPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker
        #dataPicker
        color="primary"
        (closed)="onFocus(null, false)"
      ></mat-datepicker>
    </mat-form-field>
    <small
      class="p-error"
      id="error-data-nascimento"
      *ngIf="form.get('data_nascimento').hasError('matDatepickerParse')"
    >
      Esta data é invalida.
    </small>
    <small
      class="p-error"
      id="error-data-nascimento"
      *ngIf="form.get('data_nascimento').hasError('invalidDate')"
    >
      Data não pode ser posterior a atual
    </small>
    <small
      class="p-error"
      id="error-data-nascimento"
      *ngIf="form.get('data_nascimento').hasError('isEmptyValue')"
    >
      Valor inválido remova os espaços em branco
    </small>
  </div>

  <div class="col-md-12 mt-3" *ngIf="showObs">
    <span class="p-float-label">
      <textarea
        rows="8"
        cols="100"
        pInputTextarea
        style="resize: none;"
        id="inputtext-descricao"
        [formControl]="form.get('observacao')"
        class="input-filters-text-area"
      ></textarea>
      <label for="inputtext-descricao">Observação</label>
    </span>
    <div class="flex width-100 aling-items-center justify-content-between">
      <small
        class="p-error"
        *ngIf="form.get('observacao').hasError('maxlength')"
      >
        {{ messages.observacao.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('observacao').hasError('isEmptyValue')"
      >
        {{ messages.observacao.isEmptyValue }}
      </small>
      <mat-hint
        [class]="
          form.get('observacao').invalid
            ? ''
            : 'width-100 flex justify-content-end'
        "
      >
        {{
          form.controls.observacao.value
            ? form.controls.observacao.value.length
            : 0
        }}/500
      </mat-hint>
    </div>
  </div>
</div>
